<template>
    <div>
        <v-container fluid pt-0 grid-list-xl>
            <section-tooltip title="Partner"></section-tooltip>
            <app-card customClasses="mb-30 inherit-overflow">
                <div>
                    <h3>Contact Formula 1</h3>{{ selectedEvent.eventName }}
                </div>
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" small absolute top right @click="excelExport">
                        <v-icon dark>grid_on</v-icon>
                    </v-btn>
                    <span>Export Excel</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn slot="activator" :loading="isAllDownloading" style="margin-right:60px" fab dark color="blue"
                        small absolute top right @click="downloadAll">
                        <v-icon dark>download</v-icon>
                    </v-btn>
                    <span>Download all Documents</span>
                </v-tooltip>
                <div class="partner-contact-container">
                    <v-data-table v-bind:headers="headers" :items="selectedEvent.partners" hide-actions>
                        <template slot="items" slot-scope="props">
                            <!-- <td @click="showEvent(props.item)">{{ props.item.id }}</td> -->
                            <td @click="showEvent(props.item)">{{ props.item.name }}</td>
                            <!-- <td @click="showEvent(props.item)">{{ props.item.amount }}</td> -->
                            <!-- <td style="display:flex;align-items:center;">
                                <v-text-field type="number" style="width:20px"></v-text-field>
                                <v-btn icon>
                                    <v-icon class="grey--text">
                                        save</v-icon>
                                </v-btn>
                            </td> -->
                            <td v-if="buildPartnerLink(props.item) !== ''">
                                <a :href="buildPartnerLink(props.item)" target="_blank">Partner
                                    Registration Link
                                </a>
                                <v-btn icon>
                                    <v-icon class="grey--text" @click="copyLink(buildPartnerLink(props.item))">
                                        content_copy</v-icon>
                                </v-btn>
                            </td>
                            <td v-if="buildPartnerLink(props.item) === ''">
                                Please let an admin setup the link in the user Settings
                            </td>
                        </template>
                    </v-data-table>
                </div>
            </app-card>
        </v-container>
    </div>
</template>
    
<script>
import { mapGetters } from 'vuex'
import api from 'api-client'
const zip = require("jszip");

export default {
    data() {
        return {
            headers: [
                // {
                //     text: 'ID',
                //     value: "id",
                //     align: 'left',
                // },
                {
                    text: 'Name',
                    value: "name",
                    align: 'left',
                },
                // {
                //     text: 'Requested Tickets',
                //     align: 'left',
                // },
                // {
                //     text: 'Accepted Tickets',
                //     align: 'left',
                // },
                {
                    text: 'Deeplink',
                    value: "link",
                    align: 'left',
                }
            ],
            isAllDownloading: false,
        }
    },
    computed: {
        ...mapGetters([
            'selectedEvent',
            'user'
        ]),
    },
    methods: {
        showEvent(args) {
            this.$router.push({
                name: 'guest-details.event-details',
                params: {
                    eventId: this.eventId,
                    partnerId: args.id
                }
            })
        },
        buildPartnerLink(item) {
            if (this.user.settings.partnerLinkPart)
                return `https://www.gpt-worldwide.com/${this.user.settings.partnerLinkPart}/de/guest-registration/${this.selectedEvent.eventId}/${item.id}/${this.user.company.id}`
            else {
                return '';
            }
        },
        copyLink(link) {
            navigator.clipboard.writeText(link);
        },
        async excelExport() {
            api.downloadExcelForPartner({
                eventInfo: {
                    name: this.selectedEvent.eventName,
                    eventId: this.selectedEvent.eventId
                },
                companyId: this.user.company.id,
                contactDetails: this.user.partnerDetailsContact
            }).then((response) => {
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', 'partner-guest-list.xlsx')
                document.body.appendChild(link)
                link.click()
            })
                .catch((error) => console.log(error))

        },
        async getBlob(url) {
            if (url !== '') {
                const image = await fetch(url)
                const imageBlob = await image.blob()
                return imageBlob;
            }
        },
        async downloadAll() {
            this.isAllDownloading = true;
            const zipFile = new zip();
            const params = {
                query: {
                    event_id: this.selectedEvent.eventId,
                }
            }
          
            
            for (let pI = 0; pI < this.selectedEvent.partners.length; pI++) {
                const partner = this.selectedEvent.partners[pI];
                const partnerFolder = zipFile.folder((pI + 1) + "_" + partner.name)
                params.query.partner_id = partner.id;
                let eventGuests =  (await api.getEventGuests(params)).items;
                for (let index = 0; index < eventGuests.length; index++) {
                    const g = eventGuests[index];
                    
                    const userFolder = partnerFolder.folder((index + 1) + "_" + g.first_name + '_' + g.last_name)

                    if (g.image_path) {
                        const imageBlob = this.getBlob(g.image_path)
                        userFolder.file(g.last_name + '_' + g.first_name + '.jpeg', imageBlob)
                    }
                    if (g.document_path) {
                        const documentBlob = this.getBlob(g.document_path)
                        userFolder.file(g.last_name + '_' + g.first_name + '.pdf', documentBlob)
                    }

                }
            }

            zipFile.generateAsync({ type: "blob" }).then((file) => {
                var fileName = new Date().toISOString() + "_corona-documents.zip";
                const url = window.URL.createObjectURL(file)
                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                this.isAllDownloading = false;
            })
        }
    },
    created() {
        if (this.$route.params.eventId) {
            this.eventId = this.$route.params.eventId;
            this.$store.dispatch('getGuestDetailsEvent', this.eventId);
        } else {
            this.$router.push({ name: 'guest-details.events' });
        }
    }
}
</script>
<style lang="scss">
.partner-contact-container {
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>
    